import {Component, OnInit, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {TdoTableBaseItemModel} from '../../../tdo-controls/common/tdo-table/models/tdo-table-base-item.model';
import {ITdoTableItemModel} from '../../../tdo-controls/common/tdo-table/interfaces/i-tdo-table-item.model';
import {TdoTableActionsEnum, TdoTableModel} from '../../../tdo-controls/common/tdo-table/models/tdo-table.model';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {SelectionModel} from '@angular/cdk/collections';
import {MatSnackBar} from '@angular/material/snack-bar';
import {TdoTableEvent} from '../../../tdo-controls/common/tdo-table/models/tdo-table.event';
import {ConfigInsurancePayerIdModelFrontEnd} from '../models/config-insurance-payer-id-frontend';
import {InsuranceService} from '../../insurance/insurance.service';
import {TdoTableComponent} from '../../../tdo-controls/common/tdo-table/tdo-table.component';
import {ConfigurationService} from '../configuration.service';

export class TableViewData extends TdoTableBaseItemModel implements ITdoTableItemModel {
  actions = [TdoTableActionsEnum.DELETE];
  PayerIDperNEIC: string;
  Oragnization: string;
  model: ConfigInsurancePayerIdModelFrontEnd;

  getActionTooltip(actionName: string): string {
    const tooltip = '';
    return tooltip;
  }
}

@Component({
  selector: 'app-payer-id-configuration',
  templateUrl: './payer-id-configuration.component.html',
  styleUrls: ['./payer-id-configuration.component.scss']
})

export class PayerIdConfigurationComponent implements OnInit {

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(TdoTableComponent) tdoTable: TdoTableComponent;

  // Table
  tableModel: TdoTableModel;
  displayedColumns: string[] = ['PayerIDperNEIC', 'Oragnization'];
  displayedColumnsLabels: string[] = ['Code', 'Payer Name'];
  dataSource: MatTableDataSource<TableViewData>;
  selection = new SelectionModel<TableViewData>(false, []);
  tableViewData: TableViewData[];

  codeRevert: string;
  organizationRevert: string;

  cfgInsurancePayerIDs: ConfigInsurancePayerIdModelFrontEnd[] = [];
  selectedPayer: ConfigInsurancePayerIdModelFrontEnd;

  isSaved: boolean = false;

  saveDisabled: boolean = true;
  isEditing: boolean = false;
  isLoading: boolean = false;

  constructor(
    private snackBar: MatSnackBar,
    private insuranceService: InsuranceService,
    public configurationService: ConfigurationService
  ) { }

  ngOnInit(): void {
    // get payers
    this.insuranceService.getAllInsurancePayersFrontEnd().subscribe((payers) => {
      this.cfgInsurancePayerIDs = payers;

      // select first payer
      if (this.cfgInsurancePayerIDs.length > 0) {
        this.selectedPayer = payers[0];
      }

      // load tdo table
      this.refreshTableViewData();
    }, err => {
      this.createMessage('Error loading payers', 'Error');
    });
  }

  // Data change
  refreshTableViewData() {
    this.tableViewData = Array.from(this.cfgInsurancePayerIDs, (_) => {
      const model = new TableViewData();
      model.PayerIDperNEIC = _.PayerIDperNEIC;
      model.Oragnization = _.Oragnization;
      model.isSelected = _.PayerID === this.selectedPayer.PayerID;
      model.model = _;
      return model;
    });
    if (!this.tableModel) {
      this.dataSource = new MatTableDataSource(this.tableViewData);
      this.tableModel = new TdoTableModel(this.displayedColumns, this.displayedColumnsLabels, this.dataSource, 'PayerIDperNEIC', 'asc');
      this.tableModel.searchPredicate = (data: TableViewData, filter: string) => {
        if (data.PayerIDperNEIC.toLowerCase().includes(filter) || data.Oragnization.toLowerCase().includes(filter)) {
          return true;
        }
      };
    }
    else {
      (this.dataSource as MatTableDataSource<TableViewData>).data = this.tableViewData;
      (this.dataSource as MatTableDataSource<TableViewData>)._updateChangeSubscription();

      if (this.selectedPayer) {
        this.tdoTable.selectRow(this.selectedPayer);
      }
    }
  }

  onSave(event) {
    this.configurationService.setClean();
    // reset saved vars
    this.isSaved = false;
    this.isLoading = true;

    this.codeRevert = this.selectedPayer.PayerIDperNEIC;
    this.organizationRevert = this.selectedPayer.Oragnization;

    // save changes to db
    const payers: ConfigInsurancePayerIdModelFrontEnd[] = [];
    payers.push(this.selectedPayer);
    this.insuranceService.saveInsurancePayers(payers).subscribe(save => {
      if (save) {
        // save successful
        this.createMessage('Payer saved', 'Success');
        this.isSaved = true;

        // update local models
        this.cfgInsurancePayerIDs.forEach(a => {
          if (a.PayerID === this.selectedPayer.PayerID) {
            a.PayerIDperNEIC = this.selectedPayer.PayerIDperNEIC;
            a.Oragnization = this.selectedPayer.Oragnization;
            a.isSaved = true;
          }
        });
        this.updateTdoTables();

        this.isLoading = false;
      }
    }, err => {
      this.createMessage('Error saving payer', 'Error');
      this.isLoading = false;
    });
  }

  onCancel(event) {
    this.configurationService.setClean();
    this.saveDisabled = true;
    this.isEditing = false;

    // revert any changes to selected payer
    this.selectedPayer.Oragnization = this.organizationRevert;
    this.selectedPayer.PayerIDperNEIC = this.codeRevert;

    this.cfgInsurancePayerIDs = this.cfgInsurancePayerIDs.filter(a => a.isSaved !== false);

    this.updateTdoTables();
  }

  onEdit(event) {
    this.saveDisabled = false;
    this.isEditing = true;

    this.organizationRevert = this.selectedPayer.Oragnization;
    this.codeRevert = this.selectedPayer.PayerIDperNEIC;
  }

  onTdoTableItemActionClick(event: TdoTableEvent): void {
    const model = (event.value as TableViewData).model;
  }

  onTdoTableItemClick(event: TdoTableEvent): void {
    const l = this.configurationService.checkIsDirty();
    if (l) {
      l.subscribe((res) => {
        if (res) {
          const row = event.value as TableViewData;
          this.selectedPayer = row.model;
          this.isEditing = false;
          this.saveDisabled = true;
          return;
        } else {
          // Set selection back to prior because it was cancelled // TDO switch to new tdo table
        }
      });
    } else {
      const row = event.value as TableViewData;
      this.selectedPayer = row.model;
      this.isEditing = false;
      this.saveDisabled = true;
    }
  }

  updateTdoTables() {
    // update table
    this.refreshTableViewData();
  }

  createMessage(message, type) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: 'top'
    });
  }

  addPayer() {
    this.isLoading = true;
    this.insuranceService.createInsurancePayer().subscribe(payer => {
      if (payer) {
        // add successful
        this.selectedPayer = payer;
        this.cfgInsurancePayerIDs.push(payer);
        this.updateTdoTables();
        this.createMessage('Payer added', 'Success');
        this.isSaved = true;

        // simulate edit
        this.saveDisabled = false;
        this.isEditing = true;
        this.organizationRevert = this.selectedPayer.Oragnization;
        this.codeRevert = this.selectedPayer.PayerIDperNEIC;

        this.isLoading = false;
      }
    }, err => {
      this.createMessage('Error adding payer', 'Error');
      this.isLoading = false;
    });
  }

  onNew(event) {
    this.addPayer();
  }
}
